const ITEMS = [
  "Create", "Produce", "Distribute", "License", "Operate", "Experience",
  "Immersive Entertainment", "Location-Based XR", "Free-Roaming VR", "Global Distribution",
];

export const Marquee = ({ className = "" }) => (
  <div className={`relative overflow-hidden border-y border-white/[0.06] py-7 ${className}`} data-testid="editorial-marquee">
    <div className="flex whitespace-nowrap animate-marquee w-max">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex items-center" aria-hidden={copy === 1}>
          {ITEMS.map((item, i) => (
            <span key={item} className="flex items-center">
              <span className={`font-serif text-3xl md:text-5xl tracking-tight px-8 ${i % 2 ? "text-stroke" : "text-white/85"}`}>
                {item}
              </span>
              <span className="w-1.5 h-1.5 rounded-full bg-white/25" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
